import { Icon } from 'antd';
import React from 'react';
import moment from 'moment';
import * as S from './styles';
import { withTranslation } from 'react-i18next';
import { JOB_DETAILS_UI } from '../TranslationValues';

const NAMESPACES = ['JOB_DETAILS_UI', 'STATUS_MONITORING'];

const DraftStatus = ({ batch, onContinueEdit, handleCancel, t }) => {
    const batchTypeMap = {
        STANDARD: { key: 'STANDARD_LABEL', value: 'Standard' },
        ADVANCED: { key: 'ADVANCED_LABEL', value: 'Advanced' },
        HYBRID: { key: 'HYBRID_LABEL', value: 'Hybrid' },
    };

    const channelMap = {
        PRINT: { key: 'CHANNEL_DOCUMENT', value: 'Documents' },
        EMAIL: { key: 'CHANNEL_EMAIL', value: 'Email' },
        MESSAGES: { key: 'CHANNEL_MESSAGES', value: 'Messages' },
    };

    return (
        <>
            {/* Draft Info Card */}
            <S.DraftCard>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                    <S.IconCircle bgColor="#9c179e">
                        <Icon type="info-circle" style={{ fontSize: '24px', color: 'white' }} />
                    </S.IconCircle>
                    <S.CardContent>
                        <S.CardTitle>{t(JOB_DETAILS_UI.DRAFT_HEADER.key, JOB_DETAILS_UI.DRAFT_HEADER.value)}</S.CardTitle>
                        <S.CardText>
                            {t(JOB_DETAILS_UI.DRAFT_DESCRIPTION.key, JOB_DETAILS_UI.DRAFT_DESCRIPTION.value, { currentStep: batch.currentStep, totalSteps: batch.totalSteps })}
                        </S.CardText>
                        <S.ButtonGroup>
                            <S.PrimaryButton onClick={onContinueEdit}>
                                <Icon type="edit" />
                                {t(JOB_DETAILS_UI.CONTINUE_EDITING.key, JOB_DETAILS_UI.CONTINUE_EDITING.value)}
                            </S.PrimaryButton>
                            <S.SecondaryButton onClick={handleCancel}>
                                <Icon type="close-circle" />
                                {t(JOB_DETAILS_UI.DISCARD_DRAFT.key, JOB_DETAILS_UI.DISCARD_DRAFT.value)}
                            </S.SecondaryButton>
                        </S.ButtonGroup>
                    </S.CardContent>
                </div>
            </S.DraftCard>

            {/* Progress Indicator */}
            <S.ContentCard>
                <S.CardHeader>{t(JOB_DETAILS_UI.SETUP_PROGRESS.key, JOB_DETAILS_UI.SETUP_PROGRESS.value)}</S.CardHeader>
                <S.ProgressContainer>
                    <S.ProgressInfo>
                        <S.ProgressText>{t(JOB_DETAILS_UI.STEP_PROGRESS.key, JOB_DETAILS_UI.STEP_PROGRESS.value, { currentStep: batch.currentStep, totalSteps: batch.totalSteps })}</S.ProgressText>
                        <S.ProgressPercent>{Math.round((batch.currentStep / batch.totalSteps) * 100)}%</S.ProgressPercent>
                    </S.ProgressInfo>
                    <S.ProgressBarWrapper>
                        <S.ProgressBar width={`${(batch.currentStep / batch.totalSteps) * 100}%`} />
                    </S.ProgressBarWrapper>
                </S.ProgressContainer>
            </S.ContentCard>

            {/* Saved Details */}
            {batch.jobDetails && (
                <S.ContentCard>
                    <S.CardHeader>{t(JOB_DETAILS_UI.SAVED_DETAILS.key, JOB_DETAILS_UI.SAVED_DETAILS.value)}</S.CardHeader>
                    <S.DetailsGrid>
                        <S.DetailItem>
                            <S.DetailLabel>{t(JOB_DETAILS_UI.JOB_NAME.key, JOB_DETAILS_UI.JOB_NAME.value)}</S.DetailLabel>
                            <S.DetailValue>{batch.jobDetails.jobName}</S.DetailValue>
                        </S.DetailItem>
                        <S.DetailItem>
                            <S.DetailLabel>{t(JOB_DETAILS_UI.JOB_TYPE.key, JOB_DETAILS_UI.JOB_TYPE.value)}</S.DetailLabel>
                            <S.DetailValue>
                                {batchTypeMap[batch.jobDetails.jobType]
                                    ? t(batchTypeMap[batch.jobDetails.jobType].key, batchTypeMap[batch.jobDetails.jobType].value)
                                    : batch.jobDetails.jobType}
                            </S.DetailValue>
                        </S.DetailItem>
                        <S.DetailItem>
                            <S.DetailLabel>{t(JOB_DETAILS_UI.DELIVERY_CHANNEL.key, JOB_DETAILS_UI.DELIVERY_CHANNEL.value)}</S.DetailLabel>
                            <S.DetailValue>
                                {channelMap[batch.jobDetails.format?.toUpperCase()]
                                    ? t(channelMap[batch.jobDetails.format?.toUpperCase()].key, channelMap[batch.jobDetails.format?.toUpperCase()].value)
                                    : batch.jobDetails.format}
                            </S.DetailValue>
                        </S.DetailItem>
                        <S.DetailItem>
                            <S.DetailLabel>{t(JOB_DETAILS_UI.CREATED.key, JOB_DETAILS_UI.CREATED.value)}</S.DetailLabel>
                            <S.DetailValue>{moment(batch.createdTime).format('Do MMM YYYY, h:mm A')}</S.DetailValue>
                        </S.DetailItem>
                    </S.DetailsGrid>
                </S.ContentCard>
            )}
        </>
    );
};

export default withTranslation(NAMESPACES)(DraftStatus);
